import { render, staticRenderFns } from "./TrialQuestionnaireForm.vue?vue&type=template&id=dc0902a8&"
import script from "./TrialQuestionnaireForm.vue?vue&type=script&lang=js&"
export * from "./TrialQuestionnaireForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormSelect, BFormGroup, BFormInput, BFormInvalidFeedback, BSpinner, BForm} from 'bootstrap-vue'
    installComponents(component, {BFormSelect, BFormGroup, BFormInput, BFormInvalidFeedback, BSpinner, BForm})
    

export default component.exports